import { getClassNames } from '@websolutespa/bom-core';
import { useLlmView } from '../../../useLlm/useLlmView';
import style from './page-trigger.module.scss';

export const PageTrigger: React.FC = () => {
  const { open } = useLlmView(state => state.actions);
  return (
    <button type="button" className={getClassNames(style.trigger, '-trigger')} onClick={() => open()} aria-label="Open assistant">
      <div className={style.icon}></div>
    </button>
  );
};
